export default __webpack_public_path__ + "static/media/home-business-tab-img04.588f2c7a.jpg";